import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
class Deceased extends Component {
    constructor(props) {
        super(props);

        this.saveAndContinue = this.saveAndContinue.bind(this);
    }

    saveAndContinue(e) {
        e.preventDefault()

        // Get values via this.refs
        let data = {
            title: this.refs.title.value,
            gender: this.refs.gender.value,
            surname: this.refs.surname.value,
            first_name: this.refs.first_name.value,
            other_name: this.refs.other_name.value,
        }

        this.props.saveValues(data, 'deceased', "noindex")
        this.props.nextStep()
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="text-danger mb-4">Deceased Data</h4>
                                <form onSubmit={this.saveAndContinue}>
                                    <div className="row">
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Title<span className="text-danger">*</span></label>
                                            <select ref="title" required className="form-control" defaultValue={this.props.fieldValues.title}>
                                                <option value="" hidden>Select...</option>
                                                <option value="Mr">Mr</option>
                                                <option value="Miss">Miss</option>
                                                <option value="Mrs">Mrs</option>
                                                <option value="Chief">Chief</option>
                                                <option value="Dr.">Dr.</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Surname<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="surname" placeholder="Surname" defaultValue={this.props.fieldValues.surname} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>First Name<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="first_name" placeholder="First Name" defaultValue={this.props.fieldValues.first_name} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Other Name</label>
                                            <Form.Control type="text" className="form-control" ref="other_name" placeholder="Other Name" defaultValue={this.props.fieldValues.other_name} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Gender<span className="text-danger">*</span></label>
                                            <select ref="gender" required className="form-control" defaultValue={this.props.fieldValues.gender}>
                                                <option value="" hidden>Select...</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </select>
                                        </Form.Group>
                                    </div>
                                    <button type="submit" className="btn btn-primary mr-2">Save and Continue</button>
                                </form>
                            </div >
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Deceased;